import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { RecordWorkspaceAssetsTable } from "@/features/records/components";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records/$recordId/workspace/assets",
)({
	component: RecordWorkspaceAssetsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Job-hosted Record workspace Assets tab — association list.
 * Row open nests an asset drawer under this tab; Workspace jumps to the
 * job-scoped asset workspace.
 */
function RecordWorkspaceAssetsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records/$recordId/workspace/assets",
	});

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<RecordWorkspaceAssetsTable
				orgId={params.orgId}
				recordId={params.recordId}
				jobId={params.jobId}
				assetNavTarget="jobHosted"
				syncSearchToUrl={false}
			/>
			<Outlet />
		</div>
	);
}
